import Config from 'react-native-config';
import { isDfdAuthenticatedSelector } from 'store/authentication/selectors';
import store from 'store/ReduxStoreContainer';

export const getGuestEndpoint = (): string => {
  const state = store.getState();
  const auth = isDfdAuthenticatedSelector(state);
  if (auth) return '';
  return '/p';
};

export const getSymptomCheckerService = (
  endpointSymptomChecker: string,
  endpointExpansion: string
) => {
  const SC_EXPANSION_ENABLED = Config.SYMPTOM_CHECKER_GYANT_EXPANSION_ENABLED === 'enabled';
  const client = SC_EXPANSION_ENABLED ? 'dispatcher' : 'symptomChecker';
  const url = SC_EXPANSION_ENABLED ? endpointExpansion : endpointSymptomChecker;
  return { SC_EXPANSION_ENABLED, client, url };
};
